module.exports = __webpack_public_path__ + "img/m-res.5f02cc0a.webp";